import React, { useEffect, useState } from 'react';
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { makeStyles } from '@mui/styles';

// Services
import { updateTaskStatus } from '../../../../services/tasksQueue.service';

// Types
import { DataValues } from '../../../../types/Settings';

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 110,
    height: '20px',
    whiteSpace: 'nowrap',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  selectInput: {
    padding: 0,
    '& .MuiOutlinedInput-root': {
      border: 'none',
      fontSize: '13.12px',
    },
    '& .MuiSelect-select': {
      fontSize: '13.12px',
    },
    '& .MuiInputBase-input': {
      fontSize: '13.12px',
    },
  },
  selectRoot: {
    fontSize: '13.12px',
  },
  menuItem: {
    fontSize: '13.12px',
  },
  span: {
    fontSize: '13.12px',
    display: 'flex',
    alignItems: 'center',
  },
}));

const isStatus200 = (response: any): boolean => {
  return typeof response.status === 'number' && response.status === 200;
};

const TasksQueueStatus = ({ taskStatus, taskId, handleStatusChanged, settingStates }) => {
  const classes = useStyles();

  const [value, setValue] = useState<number>(taskStatus);

  useEffect(() => {
    if (taskStatus !== value) {
      setValue(taskStatus);
    }
  }, [taskStatus, value]);

  const handleChange = async (event: SelectChangeEvent<number>) => {
    const newStatus = event.target.value as number;
    setValue(newStatus);

    const response = await updateTaskStatus(taskId, { status: newStatus });
    if (isStatus200(response)) {
      handleStatusChanged();
    }
  };

  return (
    <FormControl className={classes.formControl}>
      {value === 3 ? (
        <span className={classes.span}>{settingStates.taskStatus?.value.find((task) => task.text === value)?.value}</span>
      ) : (
        <Select value={value} onChange={handleChange} classes={{ root: classes.selectRoot }} variant='standard' disableUnderline>
          {settingStates.taskStatus?.value.map((task) => {
            const taskColor = settingStates.taskStatusColor?.value.find((v: DataValues) => v.text === task.text);
            return (
              <MenuItem key={`${taskId}-${task.text}`} value={task.text} className={classes.menuItem} onClick={(event) => event.stopPropagation()}>
                <span style={{ color: taskColor?.value ?? '' }}>{task.value}</span>
              </MenuItem>
            );
          })}
        </Select>
      )}
    </FormControl>
  );
};

export default TasksQueueStatus;
